import { z } from "zod";
import { TaskPriority, TaskType } from "@common/types/task";
import {
    TaskTemplateAssigneeRole,
    TaskTemplateDeadlineAnchor,
} from "@common/types/taskTemplate";
import { viewConfigValueSchema } from "@common/schemas/task-template.schema";

export const OrganizationTaskTemplateSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    workspaceId: z.string().uuid().nullable(),
    title: z.string(),
    description: z.string().nullable(),
    type: z.nativeEnum(TaskType).nullable(),
    priority: z.nativeEnum(TaskPriority).nullable(),
    initialMessage: z.string().nullable(),
    viewConfig: viewConfigValueSchema,
    estimatedTime: z.number().int().min(0).nullable(),
    groupId: z.string().uuid().nullable(),
    closeStageId: z.string().uuid().nullable(),
    assigneeId: z.number().int().nullable(),
    assigneeRole: z.nativeEnum(TaskTemplateAssigneeRole).nullable(),
    externalDeadline: z.number().int().min(0).nullable(),
    deadlineAnchor: z.nativeEnum(TaskTemplateDeadlineAnchor).nullable(),
    version: z.number().int().min(1),
    archivedAt: z.coerce.date().nullable(),
    createdByUserId: z.number().int().nullable(),
    updatedByUserId: z.number().int().nullable(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});

export type OrganizationTaskTemplate = z.infer<
    typeof OrganizationTaskTemplateSchema
>;
